import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../config';

const ENTITY_LABELS = {
  contract: 'Contract',
  fee_setting: 'Fee setting',
  contract_item: 'Contract item',
};

function formatWhen(value) {
  if (!value) return '—';
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return value;
  return parsed.toLocaleString();
}

const ContractChangeHistory = ({ contractVuid }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [events, setEvents] = useState([]);

  useEffect(() => {
    if (!contractVuid) return undefined;
    let cancelled = false;
    const load = async () => {
      setLoading(true);
      setError('');
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`${API_BASE_URL}/api/contracts/${contractVuid}/change-history`, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });
        if (!cancelled) setEvents(response.data?.events || []);
      } catch (err) {
        if (!cancelled) {
          setEvents([]);
          setError(err.response?.data?.error || err.message || 'Failed to load history');
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    load();
    return () => {
      cancelled = true;
    };
  }, [contractVuid]);

  if (loading) {
    return <p className="text-sm text-gray-500">Loading history…</p>;
  }
  if (error) {
    return <p className="text-sm text-red-700">{error}</p>;
  }
  if (!events.length) {
    return <p className="text-sm text-gray-500">No contract or fee setting changes have been recorded yet.</p>;
  }

  return (
    <div className="overflow-x-auto border border-gray-200 rounded-md">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">When</th>
            <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">User</th>
            <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Area</th>
            <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Change</th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {events.map((event) => (
            <tr key={event.vuid}>
              <td className="px-4 py-2 text-sm text-gray-900 whitespace-nowrap">{formatWhen(event.saved_at)}</td>
              <td className="px-4 py-2 text-sm text-gray-900 whitespace-nowrap">{event.saved_by || '—'}</td>
              <td className="px-4 py-2 text-sm text-gray-900 whitespace-nowrap">
                {ENTITY_LABELS[event.entity_type] || event.entity_type}
              </td>
              <td className="px-4 py-2 text-sm text-gray-900">{event.summary}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ContractChangeHistory;
